import styled from "@emotion/styled";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { BiImageAdd } from "react-icons/bi";
import Layout from "../layout/Layout";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateUser, singleUser } from "../../../states/actions/userAction";
import { useTranslation } from "react-i18next";

const UpdateUser = () => {
  const { id } = useParams();

  const [category, setCategory] = useState("");

  const handleChange = (event) => {
    setCategory(event.target.value);
  };

  // use form
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    onReset();
  }, []);
  const onReset = async () => {
    const result = await dispatch(singleUser(id));
    // console.log(result);
    reset(result.payload);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (data, e) => {
    //data.photo1 = getImg;
    const formData = new FormData();
    Object?.entries(data).map((entry) => {
      const [key, value] = entry;
      formData.append(key, value);
    });

    // dispatch
    dispatch(updateUser({ formData: formData, id: data.id }));
    reset();
    setTimeout(function () {
      navigate("/customers");
    }, 500);
  };
  const { t: translate } = useTranslation(["loginAndregister"]);
  return (
    <Layout title={"Users"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Typography variant="h6" sx={{ marginBottom: "14px" }}>
          {translate("Update user info")}
        </Typography>
        <Paper
          sx={{
            boxShadow: "none !important",
            borderRadius: "12px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            p: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ my: 2 }}>
              <TextField
                // label="Medicine Name"
                placeholder="Medicine Name"
                variant="outlined"
                size="small"
                fullWidth
                {...register(`firstName`, {
                  required: true,
                })}
              />
            </Box>
            {/* <Box sx={{ my: 2 }}>
              <TextField
                // label="Medicine Name"
                variant="outlined"
                size="small"
                fullWidth
                {...register(`lastName`, {
                  required: true,
                })}
              />
            </Box> */}
            <Box sx={{ mt: 4 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  {translate("Role")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={handleChange}
                  {...register(`role`, {
                    required: true,
                  })}
                >
                  <MenuItem value="member">{translate("Member")}</MenuItem>
                  <MenuItem value="mentor">{translate("Mentor")}</MenuItem>
                  <MenuItem value="admin">{translate("Admin")}</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ my: 2 }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                {...register(`email`, {
                  required: true,
                })}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "30px",
                gap: 4,
              }}
            >
              <Button
                variant="contained"
                sx={{ borderRadius: "5px" }}
                type="submit"
              >
                {translate("Update")}
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Layout>
  );
};

export default UpdateUser;
